import React from 'react';
import { SkeletonBlock } from '../../../components/skeleton/skeleton';

// Moved out of finance-v2/components/FinanceV2Skeleton.js's default export
// (task B2) so the finance section route can show it while the model/session
// is still resolving, without importing anything from finance-v2 — that
// folder is on its way out (task B9). PayoutDetailSkeleton, the other export
// that file carries, stays behind; it goes with finance-v2 when that folder
// is deleted.
const BalanceCardSkeleton = () => (
  <div className="rounded-md border border-slate-200 bg-white p-5 dark:border-slate-700 dark:bg-slate-800/70">
    <div className="flex items-center justify-between">
      <SkeletonBlock className="h-3.5 w-28" />
      <SkeletonBlock className="h-4 w-4 !rounded-full" />
    </div>
    <SkeletonBlock className="mt-4 h-8 w-32" />
    <SkeletonBlock className="mt-2 h-3 w-40" />
    <SkeletonBlock className="mt-1.5 h-3 w-36" />
  </div>
);

const PayoutRowSkeleton = () => (
  <tr className="border-b border-slate-100 dark:border-slate-700/60">
    <td className="py-3 pr-4">
      <SkeletonBlock className="h-4 w-20" />
    </td>
    <td className="py-3 pr-4">
      <SkeletonBlock className="h-4 w-28" />
    </td>
    <td className="py-3 pr-4">
      <SkeletonBlock className="h-5 w-20 !rounded-full" />
    </td>
    <td className="py-3 pr-4">
      <SkeletonBlock className="h-4 w-12" />
    </td>
    <td className="py-3">
      <SkeletonBlock className="h-4 w-12" />
    </td>
  </tr>
);

const FinanceSkeleton = () => (
  <div className="p-4 sm:p-6 lg:p-8 bg-white dark:bg-slate-800">
    <div className="mx-auto max-w-5xl space-y-8">
      {/* Header */}
      <div className="space-y-2">
        <SkeletonBlock className="h-6 w-32" />
        <SkeletonBlock className="h-4 w-80" />
      </div>

      {/* Balance Cards */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <BalanceCardSkeleton key={i} />
        ))}
      </div>

      {/* Early Payout Button */}
      <div>
        <SkeletonBlock className="h-10 w-32 !rounded-md" />
        <SkeletonBlock className="mt-2 h-3 w-48" />
      </div>

      {/* Payout Activity Table */}
      <div>
        <SkeletonBlock className="h-5 w-32" />
        <SkeletonBlock className="mt-2 h-3 w-96 max-w-full" />
        <div className="mt-4 overflow-hidden rounded-md border border-slate-200 dark:border-slate-700">
          <table className="w-full">
            <thead className="bg-slate-50 dark:bg-slate-800/70">
              <tr>
                <th className="px-4 py-3 text-left">
                  <SkeletonBlock className="h-3 w-14" />
                </th>
                <th className="px-4 py-3 text-left">
                  <SkeletonBlock className="h-3 w-20" />
                </th>
                <th className="px-4 py-3 text-left">
                  <SkeletonBlock className="h-3 w-14" />
                </th>
                <th className="px-4 py-3 text-left">
                  <SkeletonBlock className="h-3 w-10" />
                </th>
                <th className="px-4 py-3 text-left">
                  <SkeletonBlock className="h-3 w-16" />
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 5 }).map((_, i) => (
                <PayoutRowSkeleton key={i} />
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Payout Account */}
      <div className="rounded-md border border-slate-200 bg-white p-5 dark:border-slate-700 dark:bg-slate-800/70">
        <SkeletonBlock className="h-4 w-36" />
        <div className="mt-4 flex items-center gap-3">
          <SkeletonBlock className="h-10 w-10 !rounded-md" />
          <div className="flex-1 space-y-2">
            <SkeletonBlock className="h-4 w-48" />
            <SkeletonBlock className="h-3 w-32" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FinanceSkeleton;
